<template>
  <div id="app">
    <div v-if="!isCorrectBrowser">
      <h3>Unsupported browser. Please use Firefox</h3>
    </div>
    <div v-if="isCorrectBrowser">
      <div class="header" v-if="showHeader"></div>
      <Header
        class="header"
        v-if="showHeader"

        :show-exit="showExit"
        exit-text="Back"
        @exit="goBack"
      />

      <Modals/>

      <main class="main">
        <router-view class="p-3" />
      </main>

      <div
        class="loading"
        v-if="pending"
      />

    </div>
  </div>
</template>

<script>

import '@/styles/index.scss'

import Modals from '@/components/modals/Modals'
import Header from '@/components/layout/Header'
import { mapState, mapActions } from 'vuex';
import { detectBrowser } from '@/helpers/services/misc'


export default {
  components: { Modals, Header },
  computed: {
    ...mapState({
      pending: state => state.app.pending,
      showExit: state => !!state.app.goBackActionName
    }),
    showHeader() {
      /**Shows or hides bootom navbar for a **blacklist** of routes.
       *
       * It should be reviewed whether the menu slider is relevant at
       * all.
      */
      const isPrivate = this.$route.meta.auth;
      const pageInBlackList = ['/'].includes(this.$route.path)
      return isPrivate && !pageInBlackList
    },
    isCorrectBrowser() {
      return detectBrowser() === 'Firefox';
    }
  },
  methods: {
    ...mapActions('auth', ['refreshToken']),
    ...mapActions('app', ['goBack'])
  },
  mounted() {
    setInterval(this.refreshToken, 10 * 60 * 1000)
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.header {
  height: 50px;
}

.main {
  height: calc(100vh - 50px);
}

input[type="checkbox"] {
  display: none;
  & ~ label {
    position: relative;
    margin-left: 30px !important;
  }
  & ~ label:before {
    content: '';
    position: absolute;
    left: -30px;
    top: 3px;
    height: 20px;
    width: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  & ~ label:after {
    content: '';
    position: absolute;
    left: -30px;
    top: 3px;
    height: 20px;
    width: 20px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: $dark-blue;
    opacity: 0;
    transition: opacity .1s;
    background-image: url('./assets/images/tick.svg');
    background-size: 60%;
    background-position: center;
    background-repeat: no-repeat;
  }
  &:checked ~ label:after {
    opacity: 1;
  }

  font-weight: 100;
}

.btn-primary {
    color: #fff;
    background-color: $dark-blue;
    border-color: $dark-blue;
}
h1, h2, h3, h4, h5, h6 {
  font-weight: 100;
}

textarea.form-control {
  border: 0;
  border-bottom: 2px solid #ddd;
  padding-left: 2px;
  padding-right: 2px;
  &:focus {
    outline: 0;
    box-shadow: none;
  }
}

.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(#fff,.5);
  z-index: true;
  background-image: url('./assets/images/preloader.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100px;
}

.btn-create-assessment {
  display: inline-block;
  width: 100%;
  padding: 15px;
  border-radius: 5px;
  text-align: center;
  text-decoration: none;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  background-color: $light-blue;
}

.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
  color: #fff;
  background-color: $light-blue;
  &.active {
    background-color: $dark-blue;
  }
}

.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  color: #fff !important;
  background-color: rgba($light-blue, .7) !important;
}

</style>
